import React, { Suspense } from "react";
import { BrowserView, MobileView } from "react-device-detect";

import Slider from "./slider";
import PopularCities from "./PopularCities";
// import PropertiesSlider from './PropertiesSlider'

import "./styles.scss";
import "../../components/Footer/footer.scss";
import SliderForm from "./SliderForm";

import api from "../../api";
import { Helmet } from "react-helmet";
import { setRefId } from "../../helpers/cookie";

import * as images from "./MobileSliderPhoto";

import { useHistory } from "react-router-dom";
import LocationGroups from "./LocationGroups";
import PropertyTypes from "./PropertyTypes";
import Hero from './Hero';

const Home = ({ }) => {
  const [data, setData] = React.useState([]);

  const history = useHistory();
  const locationPathName = window.location.pathname;

  if (locationPathName.includes("detail")) {
    debugger;
    let url = window.location.href;
    let ref = url.split("?ref=");

    if (ref.length > 1) {
      setRefId(ref[1]);
    }

    history.push({
      pathname: `${locationPathName}/1`,
    });
  }

  React.useEffect(() => {
    const script = document.createElement("script");
    script.async = true;

    script.type = "application/ld+json";

    const codeStr = `
    "@context": "https://schema.org",
    "@type": "RealEstateAgent",
    "name": "Easy Rent",
    "image": "https://www.easyrent.com.mt/img/logo-green.png",
    "@id": "",
    "url": "https://www.easyrent.com.mt/",
    "telephone": "99998330",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "420 Triq D'Argens",
      "addressLocality": "Gżira",
      "postalCode": "",
      "addressCountry": "MT"
    } ,
    "sameAs": [
      "https://www.facebook.com/easyrentmt/",
      "https://www.instagram.com/easyrent.malta/",
      "https://www.youtube.com/channel/UCjo81yeSg4l4JJ3qkl79Hfw",
      "https://www.linkedin.com/company/easyrent-malta/"
    ] 
`;
    script.innerHTML = codeStr;

    document.body.appendChild(script);

    let url = window.location.href;
    let ref = url.split("?ref=");

    if (ref.length > 1) {
      setRefId(ref[1]);
    }
  }, []);

  React.useEffect(async () => {
    const res = await api.home.home();
    if (res?.result) {
      setData(res.result);
    }
  }, []);

  const PropertiesSlider = React.lazy(() => import("./PropertiesSlider"));

  return (
    <div style={{ paddingBottom: "50px" }}>
      <Helmet>
        <title>Property for Rent in Malta | Easy Rent Malta Real Estate</title>
        <meta
          name="description"
          content="Find the best apartments for rent in Malta. Easy Rent offers a wide range of long let and short let properties, commercial real estate, and more in prime locations."
        />
        <meta
          name="keywords"
          content="apartment for rent, rent in malta, real estate in malta, accommodation in malta, long lets apartments, short lets apartments, commercial property, property for sale"
        />
      </Helmet>
      <div className="home-slider">
        <BrowserView>
          <Slider />
        </BrowserView>
        <MobileView>
          {/* <div style={{ display: 'flex', justifyContent: 'center', padding: 20, backgroundImage: `url('/img/slider3.jpg')` }}>
            <SliderForm />
          </div> */}
          <div style={{ height: 500 }}>
            <img
              rel="preload"
              alt="img-mobile-slider"
              as="image"
              src={images.slider100}
              style={{ height: "500px" }}
            />
            <div
              style={{
                position: "absolute",
                top: "2%",
                right: "10%",
                zIndex: 1,
              }}
            >
              <SliderForm />
            </div>
          </div>
        </MobileView>
      </div>

      {/* <div className="App">
            <Hero />
        </div> */}

      <div style={{ margin: '20px auto', backgroundColor: '#f5f5f5', border: '2px solid #21ba45', borderRadius: '10px', textAlign: 'center', boxShadow: '0 4px 10px rgba(0,0,0,0.05)', padding: '25px' }}>
        <h1 style={{ fontWeight: 700, color: '#444', fontSize: '30px', marginBottom: '10px' }}>
          Apartment for Rent
        </h1>
        <div style={{ margin: '15px 0' }}>
          <h2 style={{ fontWeight: 600, display: 'inline-block', padding: '0 8px', color: '#555', fontSize: '20px' }}>
            Rent in Malta
          </h2>
          <h2 style={{ fontWeight: 600, display: 'inline-block', padding: '0 8px', color: '#555', fontSize: '20px' }}>
            Real Estate in Malta
          </h2>
        </div>
        <p style={{ fontSize: '16px', color: '#555', marginTop: '10px' }}>
          Find the best apartment for rent in Malta with modern living spaces, prime locations, and trusted real estate services designed to help you quickly secure the perfect home.
        </p>
        <p style={{ fontWeight: 'bold', fontSize: '22px', marginTop: '20px' }}>
          <a href="tel:99998330" style={{ color: '#21ba45', textDecoration: 'none' }}>
            Call Now! 99998330
          </a>
        </p>
      </div>
      <PopularCities />
      <LocationGroups />
      <PropertyTypes />

      <Suspense fallback={<div>loading...</div>}>
        <PropertiesSlider data={data} />
      </Suspense>
    </div>
  );
};

export default Home;
